Shopify.theme.sections.register('testimonials', {

  _initSliders: function() {
    var options = {
      controls: false,
      swipeAngle: 25,
      preventScrollOnTouch: 'auto',
      navPosition: 'bottom',
      mouseDrag: true,
      responsive: {
        992: {
          controls: true
        }
      }
    };
    tinySlider('testimonials', options);
  },

  onLoad: function() {
    this._initSliders();
  }

});